//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Returns user's settings.
 */
export function getMySettings(config?: AxiosRequestConfig | undefined): Promise<Types.UserSettingsDto> {
    let url_ = getBaseUrl() + "/api/user-settings";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetMySettings,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetMySettings?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetMySettings(_response);
    });
}

function processGetMySettings(response: AxiosResponse): Promise<Types.UserSettingsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initUserSettingsDto(resultData200);
        return Promise.resolve<Types.UserSettingsDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.UserSettingsDto>(null as any);
}

/**
 * Toggles ShowMoreCoefficients.
 */
export function toggleInventoryMaterialsOnly(config?: AxiosRequestConfig | undefined): Promise<boolean> {
    let url_ = getBaseUrl() + "/api/user-settings/toggle-inventory-materials-only";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigToggleInventoryMaterialsOnly,
        ...config,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigToggleInventoryMaterialsOnly?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processToggleInventoryMaterialsOnly(_response);
    });
}

function processToggleInventoryMaterialsOnly(response: AxiosResponse): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<boolean>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<boolean>(null as any);
}

/**
 * Toggles InventoryMaterialsOnly.
 */
export function toggleShowMoreCoefficients(config?: AxiosRequestConfig | undefined): Promise<boolean> {
    let url_ = getBaseUrl() + "/api/user-settings/toggle-more-coefficients";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigToggleShowMoreCoefficients,
        ...config,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigToggleShowMoreCoefficients?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processToggleShowMoreCoefficients(_response);
    });
}

function processToggleShowMoreCoefficients(response: AxiosResponse): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<boolean>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<boolean>(null as any);
}

/**
 * Toggles EnableObsidianIntegration.
 */
export function toggleEnableObsidianIntegration(config?: AxiosRequestConfig | undefined): Promise<boolean> {
    let url_ = getBaseUrl() + "/api/user-settings/toggle-enable-obsidian-integration";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigToggleEnableObsidianIntegration,
        ...config,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigToggleEnableObsidianIntegration?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processToggleEnableObsidianIntegration(_response);
    });
}

function processToggleEnableObsidianIntegration(response: AxiosResponse): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<boolean>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<boolean>(null as any);
}
let _requestConfigGetMySettings: Partial<AxiosRequestConfig> | null;
export function getGetMySettingsRequestConfig() {
  return _requestConfigGetMySettings;
}
export function setGetMySettingsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetMySettings = value;
}
export function patchGetMySettingsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetMySettings = patch(_requestConfigGetMySettings ?? {});
}

let _requestConfigToggleInventoryMaterialsOnly: Partial<AxiosRequestConfig> | null;
export function getToggleInventoryMaterialsOnlyRequestConfig() {
  return _requestConfigToggleInventoryMaterialsOnly;
}
export function setToggleInventoryMaterialsOnlyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigToggleInventoryMaterialsOnly = value;
}
export function patchToggleInventoryMaterialsOnlyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigToggleInventoryMaterialsOnly = patch(_requestConfigToggleInventoryMaterialsOnly ?? {});
}

let _requestConfigToggleShowMoreCoefficients: Partial<AxiosRequestConfig> | null;
export function getToggleShowMoreCoefficientsRequestConfig() {
  return _requestConfigToggleShowMoreCoefficients;
}
export function setToggleShowMoreCoefficientsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigToggleShowMoreCoefficients = value;
}
export function patchToggleShowMoreCoefficientsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigToggleShowMoreCoefficients = patch(_requestConfigToggleShowMoreCoefficients ?? {});
}

let _requestConfigToggleEnableObsidianIntegration: Partial<AxiosRequestConfig> | null;
export function getToggleEnableObsidianIntegrationRequestConfig() {
  return _requestConfigToggleEnableObsidianIntegration;
}
export function setToggleEnableObsidianIntegrationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigToggleEnableObsidianIntegration = value;
}
export function patchToggleEnableObsidianIntegrationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigToggleEnableObsidianIntegration = patch(_requestConfigToggleEnableObsidianIntegration ?? {});
}